'use client'

import { createContext } from 'react'
import { useForm } from 'react-hook-form'
import type { FieldValues } from 'react-hook-form'

import type { FormContextType, FormProps } from './types'

export const FormContext = createContext<FormContextType | null>(null)

export default function Form({ onSubmit, children, noValidate = true, ...props }: FormProps) {
	const form = useForm<FieldValues>({
		mode: 'onChange',
		reValidateMode: 'onChange',
	})

	const handleSubmit = form.handleSubmit((data) => {
		onSubmit?.(data)
	})

	return (
		<FormContext.Provider value={{ form }}>
			<form onSubmit={handleSubmit} noValidate={noValidate} {...props}>
				{children}
			</form>
		</FormContext.Provider>
	)
}
